module.exports = __webpack_public_path__ + "img/Weapon_301.7f8726b6.png";